import Card from '../../components/Card';
import data from './data';
import './experience.css';

const Experience = () => {
  return (
    <section id="experience">
      <h2>Experience & Programs</h2>
      <p>Selected programs and experiences (images can be added later).</p>

      <div className="container experience__container" data-aos="fade-up">
        {data.map((item, index) => (
          <div
            className={`experience__item ${index % 2 === 0 ? 'experience__item--left' : 'experience__item--right'}`}
            key={item.id}
          >
            <span className="experience__marker" aria-hidden="true" />
            <Card className="experience light">
              {item.image && (
                <img
                  src={item.image}
                  alt={`${item.title} logo`}
                  className={`experience__image ${item.id === 6 ? 'experience__image--dominion' : ''}`}
                />
              )}
              <div className="experience__header">
                <h4>{item.title}</h4>
                <p className="experience__organization">{item.organization}</p>
              </div>

              <div className="experience__meta">
                <p className="experience__date">{item.date}</p>
                <p className="experience__role">{item.role}</p>
              </div>
              <p className="experience__description">{item.description}</p>

              {item.link && (
                <a href={item.link} target="_blank" rel="noopener noreferrer" className="experience__link">
                  Learn more →
                </a>
              )}
            </Card>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Experience;
